// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap__1hs9M"};